module.exports = __webpack_public_path__ + "img/ZZRY_10.51ecec1c.jpg";